import { globalBackendClient } from '@mimir/client-common/globals/backendClient';
import { getGlobalRouter } from '@mimir/web/router';
import { getGlobalStore } from '@mimir/web/store';
import type { ProgressInfo } from '@mimir/common/dto/progress';
import cloneDeep from 'lodash/cloneDeep';
import type { UploadContext } from '@mimir/client-common/upload/UploadItem';
import type { ItemMetaDataDto } from '@mimir/common/dto/fieldValue';
import type { BackendClient } from '@mimir/common/util/backendClient';
import { currentFolderPath } from '@mimir/web/globals/folders';
import { searchState } from '../globals/searchState';

/**
 * Encapsulate GUI specific globals that UploadItem uses when running in the
 * Mimir UI.
 */
export class MimirUploadGui implements UploadContext {

  getCurrentFolderPath(): { name: string; }[] | null {
    return currentFolderPath.value;
  }

  refreshDisplayedMetadata(uploadItemId: string, metadata: ItemMetaDataDto): void {
    const currentRoute = getGlobalRouter().currentRoute;
    const currentItem = getGlobalStore().state.timeline.currentItem;
    if (currentRoute.name === 'itemDetails' && currentItem !== null && currentItem.id === uploadItemId) {
      getGlobalStore().commit('syncMetadata', cloneDeep(metadata));
    }
  }

  async showCompletedUpload(itemId: string, progressInfo: ProgressInfo): Promise<void> {
    return searchState.ops.injectProgressInfo({ itemId, progressInfo });
  }

  getBackendClient(): BackendClient {
    return globalBackendClient;
  }

}
